import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { toaster } from 'evergreen-ui';
import { StyledH3 } from './style';
import api from '../../../../services/api';
import ImageCropModal from '../../../../components/Campanhas/ImageCropModal';
import ImageUpload from '../../../../components/Campanhas/InputGroup/ImageUpload';
import CardPreviewLogo from '../../../../components/Campanhas/CardPreviewLogo';
import color from '../../../../config/colors.json';

const uploadLogo = ({
 idLogo, setIdLogo, setNameLogo, buttonMargin,
}) => {
	const [images, setImages] = useState([]);
	const [customerId, setCustomerId] = useState(null);
	const [modalOpen, setModalOpen] = useState(false);
	const [currentImage, setCurrentImage] = useState('');
	const [currentImageId, setCurrentImageId] = useState(0);
	const [showAlert, setShowAlert] = useState(false);
	const [dropzoneClass, setDropzoneClass] = useState('');
	const [dropzoneErrorMsg, setDropzoneErrorMsg] = useState('');
	const [uploading, setUploading] = useState(false);
	const [loading, setLoading] = useState(true);

	const userData = useSelector(state => state.user);

	useEffect(() => {
		if (showAlert === true) {
			setTimeout(() => setShowAlert(false), 5000);
		}
	}, [showAlert]);

	const fetchLogos = () => {
		api.get(`/api/v2/customers/${customerId}/logos`)
			.then((response) => {
				setImages(response.data.data);
				setLoading(false);
			});
	};

	const submitFile = (file) => {
		const data = new FormData();
		data.append('file', file);
		api.post('/api/v2/files', data)
		.then((response) => {
			setCurrentImageId(response.data.data.id);
			api.post(`/api/v2/customers/${customerId}/logos`, {
				name: '',
				file_id: response.data.data.id,
			})
			.then((responseLogo) => {
				setIdLogo(responseLogo.data.data.id);
				if (typeof setNameLogo === 'function') {
					setNameLogo(responseLogo.data.data.attributes.name || 'Logo sem nome');
				}
				fetchLogos();
				setModalOpen(true);
			})
			.catch(() => {
				toaster.danger('Erro ao cadastrar logo.');
			});
		})
		.catch(() => {
			toaster.danger('Erro ao enviar arquivo.');
		});
	};

	const submitCrop = (croppedData) => {
		api.post(`/api/v2/logos/${idLogo}/crops`, croppedData)
			.catch(() => {
				toaster.danger('Erro ao cadastrar logo.');
			});
	};

	useEffect(() => {
		if (userData.data) {
			setCustomerId(userData.data.relationships.customer.id_gearbox);
		}
	}, [userData]);

	useEffect(() => {
		fetchLogos();
	}, [customerId]);

	const onDrop = useCallback((acceptedFiles) => {
		const validTypes = ['image/png', 'image/jpg', 'image/jpeg'];
		setUploading(true);

		if (acceptedFiles.length > 1) {
			setDropzoneClass('is-invalid');
			setDropzoneErrorMsg('Ops! Só é permitida uma imagem por vez.');
			setUploading(false);
		} else if (!validTypes.includes(acceptedFiles[0].type)) {
			setDropzoneClass('is-invalid');
			setDropzoneErrorMsg('Ops! Tipo de arquivo inválido.');
			setUploading(false);
		} else if (images.length >= 6) {
			setDropzoneClass('is-invalid');
			setDropzoneErrorMsg('Ops! O limite é de 6 logos.');
			setUploading(false);
		} else {
			setDropzoneClass('');
			acceptedFiles.map((file) => {
				const reader = new FileReader();
				reader.onload = e => setCurrentImage(e.target.result);
				reader.readAsDataURL(file);
				setModalOpen(true);
				submitFile(file);
				return file;
			});
			setUploading(false);
		}
	}, [images]);

	return !loading && (
	<>
		<div className="row">
			{images.map(logo => (
				<div className="col-lg-4 mb-2">
					<CardPreviewLogo
						logo={logo}
						formOption
						formOptionLogo={idLogo}
						setFormOptionLogo={setIdLogo}
						setFormOptionName={setNameLogo}
						marginTop="0"
					/>
				</div>
			))}
		</div>
		<div className="row">
			<div className="col-12">
				<StyledH3>Se preferir, adicione um novo logo</StyledH3>
			</div>
		</div>
		<div className="row">
			<div className="col-12">
				{
						dropzoneClass === 'is-invalid'
						&& (
							<div style={
									{
										color: color.lightRed,
										fontSize: '13px',
										margin: '-10px 0 5px 0',
									}
								}
							> {dropzoneErrorMsg}
							</div>
						)
					}
				<ImageUpload
					dropzoneClass={dropzoneClass}
					maxFiles={1}
					onDrop={onDrop}
					accept="image/*"
					uploading={uploading}
					buttonMargin={buttonMargin}
				/>
			</div>
		</div>
		<ImageCropModal
			setLogoName={() => {}}
			imageId={currentImageId}
			submitCrop={submitCrop}
			image={currentImage}
			isOpen={modalOpen}
			openAction={setModalOpen}
		/>
	</>
	);
};

PropTypes.uploadLogo = {
	idLogo: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
	setIdLogo: PropTypes.func.isRequired,
	setNameLogo: PropTypes.any.isRequired,// eslint-disable-line
	buttonMargin: PropTypes.string,
};

export default uploadLogo;
